module.exports = __webpack_public_path__ + "media/Bridge-Africa-logo-1.1a99f245.mp4";